module.exports = __webpack_public_path__ + "img/表情-1.8baa044b.png";